import { useMemo } from "react";
import { withQueryParams } from "../../appointment-details/helpers/common.js";
import { useAxiosProvider } from "../components/AxiosProvider.js";
import { useQuery } from "@tanstack/react-query";
import { secondsToMilliseconds } from "date-fns";
import "date-fns/locale";
import "../../appointment-details/appointment-details.types.js";
import "react/jsx-runtime";
import "axios";
const getPhones = (axios) => async (clinicReferenceIds) => {
  const { data } = await axios.get("/api/phones", {
    params: { clinicReferenceIds, unassigned: false }
  });
  return (data == null ? void 0 : data.content) || [];
};
const usePhones = (clinicReferenceId) => {
  const { operator } = useAxiosProvider();
  const queryKey = useMemo(() => ["phones", clinicReferenceId], [clinicReferenceId]);
  const { data, ...queryResult } = useQuery({
    queryKey,
    queryFn: withQueryParams(getPhones(operator)),
    enabled: Boolean(clinicReferenceId),
    staleTime: secondsToMilliseconds(60)
  });
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  usePhones
};
